export default {
  SET_SUB_CATEGORIES(state, payloads) {
    state.subCategories = payloads;
  },
};
